import React, { useEffect } from "react";
import * as echarts from "echarts";

const MonthWisePWILoadedEmptyGraph2 = ({
  selectedMonths,
  selectedSections,
  sortedPrev,
  sortedCurr,
  selectedRT,
  selectedFy,
}) => {
  const getSectionData = (monthData, section) =>
    monthData?.data?.find((d) => d.section === section) || {};

  const calcTotal = (data, section, key) =>
    selectedMonths.reduce((sum, month) => {
      const m = data.find((o) => o.month.slice(0, 3) === month);
      return sum + Number(getSectionData(m, section)[key] || 0);
    }, 0);

  useEffect(() => {
    if (!selectedMonths.length || !selectedSections.length) return;

    const chart = echarts.init(document.getElementById("pwiChart3"));
    const rt = selectedRT.toLowerCase();
    const prevFy = selectedFy.replace(/\d+/g, (y) => +y - 1);

    const sectionData = selectedSections
      .map((section) => {
        const prevTOL = calcTotal(sortedPrev, section, `${rt}_to_loaded`);
        const currTOL = calcTotal(sortedCurr, section, `${rt}_to_loaded`);
        const prevTOE = calcTotal(sortedPrev, section, `${rt}_to_empty`);
        const currTOE = calcTotal(sortedCurr, section, `${rt}_to_empty`);

        return {
          section,
          prevTOL,
          currTOL,
          prevTOE,
          currTOE,

          total: prevTOL + currTOL + prevTOE + currTOE,
        };
      })
      .sort((a, b) => b.total - a.total);

    const label = {
      show: true,
      position: "top",
      rotate: 55,
      fontSize: 12,
      verticalAlign: "middle",
    };

    const option = {
      title: {
        text: `TO L & E– Prev (${prevFy}) vs Curr (${selectedFy})`,
        left: "center",
      },
      tooltip: { trigger: "axis" },
      legend: {
        top: 30,
        data: [
          `T/O L (${prevFy})`,
          `T/O L (${selectedFy})`,
          `T/O E (${prevFy})`,
          `T/O E (${selectedFy})`,
        ],
      },
      xAxis: {
        type: "category",
        data: sectionData.map((d) => d.section),
      },
      yAxis: { type: "value" },
      series: [
        {
          name: `T/O L (${prevFy})`,
          type: "bar",
          data: sectionData.map((d) => d.prevTOL),
          label,
        },
        {
          name: `T/O L (${selectedFy})`,
          type: "bar",
          data: sectionData.map((d) => d.currTOL),
          label,
        },
        {
          name: `T/O E (${prevFy})`,
          type: "bar",
          data: sectionData.map((d) => d.prevTOE),
          label,
        },
        {
          name: `T/O E (${selectedFy})`,
          type: "bar",
          data: sectionData.map((d) => d.currTOE),
          label,
        },
      ],
    };

    chart.setOption(option);

    const handleResize = () => {
      chart.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.dispose();
    };
  }, [
    selectedMonths,
    selectedSections,
    sortedPrev,
    sortedCurr,
    selectedRT,
    selectedFy,
  ]);

  return (
    <div className="papaDiv">
      <div
        id="pwiChart3"
        style={{ width: "100%", height: "50vh", marginTop: "30px" }}
      />
    </div>
  );
};

export default MonthWisePWILoadedEmptyGraph2;
